import { useEffect, useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SERVER_URL } from "../../util/url";

import "./dashboard.css";

function Dashboard(props) {
    const [runningWorkOrders, setRunningWorkOrders] = useState(0);
    const [closedWorkOrders, setClosedWorkOrders] = useState(0);
    const [modifiedRecipe, setModifiedRecipe] = useState(0);
    const [newRecipe, setNewRecipe] = useState(0);
    const [activity, setActivity] = useState([]);

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        fetchWorkOrders(signal);
        fetchLast30daysWorkOrders(signal);
        fetchModifiedRecipes(signal);
        fetchNewRecipe(signal);
        fetchActivity(signal);

        return () => {
            controller.abort();
        };
    }, [props.plant]);

    const fetchWorkOrders = (signal) => {
        fetch(SERVER_URL + "/workorders/count?status=RUNNING&plant=" + props.plant, {
            method: "GET",
        }, { signal })
            .then((res) => res.json())
            .then((data) => {
                setRunningWorkOrders(data.data);
            });
    };

    const fetchLast30daysWorkOrders = (signal) => {
        fetch(SERVER_URL + "/workorders/woendedlast30days?plant=" + props.plant, {
            method: "GET",
        }, { signal })
            .then((res) => res.json())
            .then((data) => {
                setClosedWorkOrders(data.data[0].count);
            });
    };

    const fetchModifiedRecipes = (signal) => {
        fetch(SERVER_URL + "/recipes/modifiedrecipescount?plant=" + props.plant, {
            method: "GET",
        }, { signal })
            .then((res) => res.json())
            .then((data) => {
                setModifiedRecipe(data.data);
            });
    };

    const fetchNewRecipe = (signal) => {
        fetch(SERVER_URL + "/recipes/newrecipescount?plant=" + props.plant, {
            method: "GET",
        }, { signal })
            .then((res) => res.json())
            .then((data) => {
                setNewRecipe(data.data);
            });
    };

    const fetchActivity = (signal) => {
        fetch(SERVER_URL + "/activity?plant=" + props.plant, {
            method: "GET",
        }, { signal })
            .then((res) => res.json())
            .then((data) => {
                setActivity(data.data);
            });
    };

    return (
        <div className="dashboard bg-light">
            <div className="py-3 mb-5">
                <div className="px-5">
                    <div className="row gx-5">
                        <div className="col-lg py-3">
                            <div className="dashboard-card card px-5 pt-4 pb-2 border bg-white">
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <p style={{ fontSize: "50px", fontWeight: "bold" }}> {newRecipe} </p>
                                    </div>
                                    <div className="pt-2">
                                        <span className="material-symbols-outlined text-danger" style={{ fontSize: "60px" }}>
                                            report
                                        </span>
                                    </div>
                                </div>
                                <br></br>
                                <div className="d-flex">
                                    <div className="col-6" style={{ width: "70%" }}>
                                        <Link
                                            className="card-text"
                                            to="/homepage/recipeslist"
                                            onClick={() => {
                                                props.setPage("recipeslist");
                                                props.setRecipeParameters("newrecipe");
                                            }}>
                                            Nuove ricette da <br></br>validare
                                        </Link>
                                    </div>
                                    <div className="col pt-1">
                                        <span className="card-icon material-symbols-outlined">arrow_forward</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg py-3">
                            <div className="dashboard-card card px-5 pt-4 pb-2 border bg-white">
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <p style={{ fontSize: "50px", fontWeight: "bold" }}>{modifiedRecipe}</p>
                                    </div>
                                    <div className="pt-2">
                                        <span className="material-symbols-outlined text-warning" style={{ fontSize: "60px" }}>
                                            checklist_rtl
                                        </span>
                                    </div>
                                </div>
                                <br></br>

                                <div className="d-flex">
                                    <div className="col-6" style={{ width: "70%" }}>
                                        <Link
                                            className="card-text"
                                            to="/homepage/recipeslist"
                                            onClick={() => {
                                                props.setPage("recipeslist");
                                                props.setRecipeParameters("recipestocheck");
                                            }}>
                                            Modifiche di ricette<br></br>da controllare
                                        </Link>
                                    </div>
                                    <div className="col pt-1" style={{ textColor: "blue" }}>
                                        <span className="card-icon material-symbols-outlined">arrow_forward</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg py-3">
                            <div className="dashboard-card card px-5 pt-4 pb-2 border bg-white">
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <p style={{ fontSize: "50px", fontWeight: "bold" }}>{runningWorkOrders}</p>
                                    </div>
                                    <div className="pt-2">
                                        <span className="material-symbols-outlined text-success" style={{ fontSize: "60px" }}>
                                            check_circle
                                        </span>
                                    </div>
                                </div>
                                <br></br>
                                <div className="d-flex">
                                    <div className="col-6" style={{ width: "70%" }}>
                                        <Link
                                            className="card-text"
                                            to="/homepage/orderslist"
                                            onClick={() => {
                                                props.setPage("orderslist");
                                                props.setOrderParameters("executionorders");
                                            }}>
                                            ODL in esecuzione
                                        </Link>
                                    </div>
                                    <div className="col pt-1">
                                        <span className="card-icon material-symbols-outlined">arrow_forward</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg py-3">
                            <div className="dashboard-card card px-5 pt-4 pb-2 border bg-white">
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <p style={{ fontSize: "50px", fontWeight: "bold" }}>{closedWorkOrders}</p>
                                    </div>
                                    <div className="pt-2">
                                        <span className="material-symbols-outlined text-success" style={{ fontSize: "60px" }}>
                                            check_circle
                                        </span>
                                    </div>
                                </div>
                                <br></br>
                                <div className="d-flex">
                                    <div className="col-6" style={{ width: "70%" }}>
                                        <Link
                                            className="card-text"
                                            to="/homepage/orderslist"
                                            onClick={() => {
                                                props.setPage("orderslist");
                                                props.setOrderParameters("last30daysorders");
                                            }}>
                                            ODL finiti negli ultimi<br></br>30 giorni
                                        </Link>
                                    </div>
                                    <div className="col pt-1">
                                        <span className="card-icon material-symbols-outlined">arrow_forward</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="h-75">
                <div className="px-5">
                    <div className="row">
                        <div className="col-md-auto align-items-start my-2">
                            <h3>Attività recenti</h3>
                        </div>
                        <div className="col-md-auto align-items-start my-2">
                            <div className="dropdown">
                                <button className="btn border dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                                    Lista Attività
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <li>
                                        <a className="dropdown-item" href="">
                                            <div className="form-check">
                                                <input
                                                    onChange={(e) => console.log(e.target.checked, e.target.value)}
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value="allActivities"
                                                    id="allActivities"
                                                />
                                                <label className="form-check-label" htmlFor="allActivities">
                                                    Tutte le attività
                                                </label>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            <div className="form-check">
                                                <input
                                                    onChange={(e) => console.log(e.target.checked, e.target.value)}
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value="checkRecipe"
                                                    id="checkRecipe"
                                                />
                                                <label className="form-check-label" htmlFor="checkRecipe">
                                                    Ricette da validare
                                                </label>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            <div className="form-check">
                                                <input
                                                    onChange={(e) => console.log(e.target.checked, e.target.value)}
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value="runningWorkOrders"
                                                    id="runningWorkOrders"
                                                />
                                                <label className="form-check-label" htmlFor="runningWorkOrders">
                                                    ODL in esecuzione
                                                </label>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            <div className="form-check">
                                                <input
                                                    onChange={(e) => console.log(e.target.checked, e.target.value)}
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value="completedWO"
                                                    id="completedWO"
                                                />
                                                <label className="form-check-label" htmlFor="completedWO">
                                                    ODL completati
                                                </label>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-auto align-items-start my-2">
                            <div className="dropdown">
                                <button className="btn border dropdown-toggle" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                                    Tutti i turni
                                </button>
                                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            <div className="form-check">
                                                <input onChange={(e) => console.log(e.target.checked, e.target.value)} className="form-check-input" type="checkbox" value="shift1" id="shift1" />
                                                <label className="form-check-label" htmlFor="shift1">
                                                    Turno 1
                                                </label>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            <div className="form-check">
                                                <input onChange={(e) => console.log(e.target.checked, e.target.value)} className="form-check-input" type="checkbox" value="shift2" id="shift2" />
                                                <label className="form-check-label" htmlFor="shift2">
                                                    Turno 2
                                                </label>
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="#">
                                            <div className="form-check">
                                                <input onChange={(e) => console.log(e.target.checked, e.target.value)} className="form-check-input" type="checkbox" value="shift3" id="shift3" />
                                                <label className="form-check-label" htmlFor="shift3">
                                                    Turno 3
                                                </label>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="px-5 pb-5 w-50">
                    <div className="card" style={{maxHeight: "500px"}}>
                        <div className="table-responsive">
                            <table className="table m-0 table-hover">
                                <tbody>
                                    {
                                        (activity.length === 0) && 
                                        (
                                            <tr>
                                                <td className="text-center">
                                                    <p className="fst-italic my-auto"> "Nessuna attività presente" </p>
                                                </td>
                                            </tr>
                                        )
                                    }
                                    {activity.map((element, index) => {
                                        return (
                                            <tr key={index}>
                                                <td className="align-middle">
                                                    <span className="material-symbols-outlined text-success" style={{ fontSize: "25px" }}>
                                                        check_circle
                                                    </span>
                                                </td>
                                                <td className="align-middle">
                                                    <Link className="activity-desc fs-5 m-0">{element.description}</Link>
                                                    <p className="fs-6 fst-italic m-0">{element.date}</p>
                                                </td>
                                                <td className="align-middle text-end">
                                                    <span className="material-symbols-outlined text-primary icon" style={{ fontSize: "25px" }}>
                                                        arrow_forward
                                                    </span>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Dashboard;
